(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7010"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7010"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7JIDn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4cb0599627fba033$export$2e2bcd8739ae039; });
/**************************************************************************
 * File: application.ts
 * Notes: Extended application functions
 **************************************************************************/ 
var $bySJi = parcelRequire("bySJi");

var $hNV7h = parcelRequire("hNV7h");

var $3yhJs = parcelRequire("3yhJs");

var $hHK49 = parcelRequire("hHK49");

var $7cBfa = parcelRequire("7cBfa");
var $4cb0599627fba033$var$API = Mindbreeze['require']('api/v2/api');
var $4cb0599627fba033$var$BaseApplication = Mindbreeze['require']('client/application');
var $4cb0599627fba033$var$$ = Mindbreeze['require']('jquery');
var $4cb0599627fba033$var$Application = $4cb0599627fba033$var$BaseApplication.extend((0, $3yhJs.default)).extend({
    fetchPreviewContent: function fetchPreviewContent(origin, location, category, categoryinstance) {
        return fetch("".concat(window.location.origin, "/search/api/v2/preview"), // `https://nyc-dev.mindbreeze.com/search/api/v2/preview`, // For VM testing only
        {
            method: "POST",
            body: JSON.stringify({
                location: location,
                category: category,
                categoryinstance: categoryinstance,
                query_expr: {
                    and: [
                        {
                            unparsed: "",
                            id: "query"
                        }
                    ]
                },
                full_html: true,
                properties: [
                    {
                        formats: [
                            "HTML"
                        ],
                        name: "title"
                    },
                    {
                        formats: [
                            "PROPERTY"
                        ],
                        name: "mes:summary"
                    },
                    {
                        formats: [
                            "HTML"
                        ],
                        name: "content"
                    },
                    {
                        formats: [
                            "HTML"
                        ],
                        name: "extension"
                    },
                    {
                        formats: [
                            "HTML"
                        ],
                        name: "html/head"
                    },
                    {
                        formats: [
                            "HTML"
                        ],
                        name: "categoryclass"
                    },
                    {
                        formats: [
                            "HTML"
                        ],
                        name: "@content"
                    },
                    {
                        formats: [
                            "HTML"
                        ],
                        name: "i18n.document-not-found"
                    },
                    {
                        formats: [
                            "HTML"
                        ],
                        name: "icon"
                    },
                    {
                        formats: [
                            "HTML"
                        ],
                        name: "i18n.date"
                    },
                    {
                        formats: [
                            "PROPERTY"
                        ],
                        name: "mes:date"
                    }
                ],
                user_context: {
                    referer: origin + "/search/apps/summary-demo/",
                    //"https://nyc-dev.mindbreeze.com" + "/search/apps/summary-demo/", // For VM testing only
                    locale: "en-US",
                    service_id: origin + "/search/apps/scripts/../scripts/../../api/v2/",
                    //"https://nyc-dev.mindbreeze.com" + "/search/apps/scripts/../scripts/../../api/v2/", // For VM testing only
                    utc_time_zone_differential_in_seconds: 3600,
                    service_url: origin + "/search/apps/scripts/../../api/v2/preview"
                }
            }),
            credentials: "include",
            headers: {
                "Content-type": "application/json; charset=UTF-8"
            }
        }).then(function(response) {
            return response.text();
        }).then(function(body) {
            return JSON.parse(body).result.properties[3].data[0].html;
        });
    },
    /*summarizeDocument: async function () {
        this.models.search.set("constraint", {
          and: [
            {
              label: "fqcategory",
              quoted_term:
                this.options.resultModel.get("category", {
                  format: "VALUE",
                }) +
                ":" +
                this.options.resultModel.get("categoryinstance", {
                  format: "VALUE",
                }),
            },
            {
              label: "mes:key",
              quoted_term: this.options.resultModel.get("mes:key", {
                format: "VALUE",
              }),
            },
          ],
        });
        const keys = this.options.resultModel.get("mes:key", {
          format: "VALUE",
        });
        const keysElement = document.getElementById("meskey");
        if (keysElement) {
          keysElement.innerHTML = keys;
        }
      },

      summarize: async function (options: any) {
        
        const content = await this.fetchPreviewContent(
          window.location.origin,
          options.model.get("location", { format: "VALUE" }),
          options.model.get("category", { format: "VALUE" }),
          options.model.get("categoryinstance", { format: "VALUE" })
        ).then((response: any) => {
          return response;
        });
        
        const llmModelElement = document.getElementById("LLMmodel");
        if (llmModelElement) {
          llmModelElement.innerHTML =
            "0e92cb9d-edce-4dce-957a-d7420c903ee6"; // LLM ID
        }
        const llmModelNameElement =
          document.getElementById("LLMmodelName");
        if (llmModelNameElement) {
          llmModelNameElement.innerHTML = "mindbreeze llm"; //llm model for feedback
        }
        const summarizePromptElement =
          document.getElementById("summarizePrompt");
        if (summarizePromptElement) {
          summarizePromptElement.setAttribute(
            "data-prompt-user-message-template",
            content
          );
        }
         this.pushStack({
          title:
            "Document summary of: " +
            options.model.get("title", { format: "VALUE" }),
          "template-ref": "summaryTemplate",
          action: "summarizeDocument",
          applicationOptions: {
            startSearch: false,
            resultModel: options.model,
          },
        });
      },

      draftDecisionDocument: async function () {
        this.models.search.set("constraint", {
          and: [
            {
              label: "fqcategory",
              quoted_term:
                this.options.resultModel.get("category", {
                  format: "VALUE",
                }) +
                ":" +
                this.options.resultModel.get("categoryinstance", {
                  format: "VALUE",
                }),
            },
            {
              label: "mes:key",
              quoted_term: this.options.resultModel.get("mes:key", {
                format: "VALUE",
              }),
            },
          ],
        });
        const keys = this.options.resultModel.get("mes:key", {
          format: "VALUE",
        });
        const keysElement = document.getElementById("meskey");
        if (keysElement) {
          keysElement.innerHTML = keys;
        }
      },

      draftDecision: async function (options: any) {
        
        const content = await this.fetchPreviewContent(
          window.location.origin,
          options.model.get("location", { format: "VALUE" }),
          options.model.get("category", { format: "VALUE" }),
          options.model.get("categoryinstance", { format: "VALUE" })
        ).then((response: any) => {
          return response;
        });
        
        const llmModelElement = document.getElementById("LLMmodel");
        if (llmModelElement) {
          llmModelElement.innerHTML =
            "0e92cb9d-edce-4dce-957a-d7420c903ee6"; // LLM ID
        }
        const llmModelNameElement =
          document.getElementById("LLMmodelName");
        if (llmModelNameElement) {
          llmModelNameElement.innerHTML = "mindbreeze llm"; //llm model for feedback
        }
        const draftDecisionPromptElement =
          document.getElementById("draftDecisionPrompt");
        if (draftDecisionPromptElement) {
          draftDecisionPromptElement.setAttribute(
            "data-prompt-user-message-template",
            content
          );
        }
         this.pushStack({
          title:
            "Decision draft of: " +
            options.model.get("title", { format: "VALUE" }),
          "template-ref": "decisionTemplate",
          action: "draftDecisionDocument",
          applicationOptions: {
            startSearch: false,
            resultModel: options.model,
          },
        });
      },*/ /*************************************************************************
   * Name: createModels
   * Params: 
   * Purpose: Called before the first views/widgets are initialized and
   *          when the app is initialized
   *************************************************************************/ createModels: function createModels() {
        this.listenTo(this, "all", function() {
            console.log('all log', arguments);
        });
        this.createUiStateModel();
    },
    /*************************************************************************
   * Name: prepareModels
   * Params: 
   * Purpose: Called when the application is initializing and create models
   *          has been called
   *************************************************************************/ prepareModels: function prepareModels() {
        this.prepareSearchModel();
        this.connectModels();
        //called on each results to build and add download actions
        var addCustomActionsTransformer = function addCustomActionsTransformer(responseData) {
            return new Promise(function(resolve) {
                responseData.resultset.results.forEach(function(result) {
                    var downloadAction = buildDownloadAction(result);
                    if (downloadAction) addAction(result, downloadAction);
                    var shareAction = buildShareAction(result);
                    if (shareAction) addAction(result, shareAction);
                });
                resolve();
            });
        };
        this.models.search.output.loadTransformers.push(addCustomActionsTransformer);
        //builds download action
        function buildDownloadAction(result) {
            var _result_properties_find_properties_find_data__value_action_preview, _result_properties_find_properties_find_data__value_action, _result_properties_find_properties_find_data_, _result_properties_find_properties_find, _result_properties_find, _result_properties;
            var title = result.properties.find(function(el) {
                return el.id == "title";
            }).properties[0].data[0].value.str;
            var current_location = null;
            if (result === null || result === void 0 ? void 0 : (_result_properties = result.properties) === null || _result_properties === void 0 ? void 0 : (_result_properties_find = _result_properties.find(function(el) {
                return el.id == "actions";
            })) === null || _result_properties_find === void 0 ? void 0 : (_result_properties_find_properties_find = _result_properties_find.properties.find(function(el) {
                return el.id == "Preview";
            })) === null || _result_properties_find_properties_find === void 0 ? void 0 : (_result_properties_find_properties_find_data_ = _result_properties_find_properties_find.data[0]) === null || _result_properties_find_properties_find_data_ === void 0 ? void 0 : (_result_properties_find_properties_find_data__value_action = _result_properties_find_properties_find_data_.value.action) === null || _result_properties_find_properties_find_data__value_action === void 0 ? void 0 : (_result_properties_find_properties_find_data__value_action_preview = _result_properties_find_properties_find_data__value_action.preview) === null || _result_properties_find_properties_find_data__value_action_preview === void 0 ? void 0 : _result_properties_find_properties_find_data__value_action_preview.content_location) {
                var _result_properties1;
                current_location = new URL((_result_properties1 = result.properties) === null || _result_properties1 === void 0 ? void 0 : _result_properties1.find(function(el) {
                    return el.id == "actions";
                }).properties.find(function(el) {
                    return el.id == "Preview";
                }).data[0].value.action.preview.content_location);
                current_location.pathname = "/search/content";
            } else return null;
            return {
                id: "Download",
                name: "Download",
                data: [
                    {
                        html: '<a tabindex="0" role="button" data-action="downloadDocument(\''.concat(current_location, "', '").concat(title, "')\">Download</a>"),
                        value: {
                            href: current_location,
                            rel: "action"
                        },
                        actionId: "Download"
                    }
                ]
            };
        }
        // builds Share action
        function buildShareAction(result) {
            var _result_properties_find_properties_find_data__value_action_preview, _result_properties_find_properties_find_data__value_action, _result_properties_find_properties_find_data__value, _result_properties_find_properties_find_data_, _result_properties_find_properties_find_data, _result_properties_find_properties_find, _result_properties_find_properties, _result_properties_find, _result_properties;
            var contentLocation = result === null || result === void 0 ? void 0 : (_result_properties = result.properties) === null || _result_properties === void 0 ? void 0 : (_result_properties_find = _result_properties.find(function(el) {
                return el.id === "actions";
            })) === null || _result_properties_find === void 0 ? void 0 : (_result_properties_find_properties = _result_properties_find.properties) === null || _result_properties_find_properties === void 0 ? void 0 : (_result_properties_find_properties_find = _result_properties_find_properties.find(function(el) {
                return el.id === "Preview";
            })) === null || _result_properties_find_properties_find === void 0 ? void 0 : (_result_properties_find_properties_find_data = _result_properties_find_properties_find.data) === null || _result_properties_find_properties_find_data === void 0 ? void 0 : (_result_properties_find_properties_find_data_ = _result_properties_find_properties_find_data[0]) === null || _result_properties_find_properties_find_data_ === void 0 ? void 0 : (_result_properties_find_properties_find_data__value = _result_properties_find_properties_find_data_.value) === null || _result_properties_find_properties_find_data__value === void 0 ? void 0 : (_result_properties_find_properties_find_data__value_action = _result_properties_find_properties_find_data__value.action) === null || _result_properties_find_properties_find_data__value_action === void 0 ? void 0 : (_result_properties_find_properties_find_data__value_action_preview = _result_properties_find_properties_find_data__value_action.preview) === null || _result_properties_find_properties_find_data__value_action_preview === void 0 ? void 0 : _result_properties_find_properties_find_data__value_action_preview.content_location;
            if (!contentLocation) return null;
            // Encode the URL before putting it into the HTML/JavaScript attribute.
            var encodedLocation = encodeURIComponent(contentLocation);
            return {
                id: "Share",
                name: "Share",
                data: [
                    {
                        html: '<a tabindex="0" role="button" onclick="shareDocument(\''.concat(encodedLocation, "', this); return false;\">Share</a>"),
                        value: {
                            href: contentLocation,
                            rel: "action"
                        },
                        actionId: "Share"
                    }
                ]
            };
        }
        //adds action to result
        function addAction(result, action) {
            var _result_properties, _result_properties1;
            if (!((_result_properties = result.properties) === null || _result_properties === void 0 ? void 0 : _result_properties.find(function(el) {
                return el.id == "actions";
            }))) return false;
            (_result_properties1 = result.properties) === null || _result_properties1 === void 0 ? void 0 : _result_properties1.find(function(el) {
                return el.id == "actions";
            }).properties.push(action);
        }
    },
    createUiStateModel: function createUiStateModel() {
        this.models.uiState = new (0, $hHK49.default)();
    },
    prepareSearchModel: function prepareSearchModel() {
        this.listenTo($4cb0599627fba033$var$API.search, 'loadoutput', this.beforeSearchModelOutputUpdate);
    // this.listenTo(this.models.search, 'computed', this.doSomethingWhenResultsAreAvailable);
    },
    connectModels: function connectModels() {
    //this.listenTo(this.models.uiState, 'change:language', this.updateLanguage);
    },
    beforeSearchModelOutputUpdate: function beforeSearchModelOutputUpdate(model, atts, options) {
        var _this = this;
        if (model === this.models.search.output) {
            var _atts_resultset;
            var results = (atts === null || atts === void 0 ? void 0 : (_atts_resultset = atts.resultset) === null || _atts_resultset === void 0 ? void 0 : _atts_resultset.results) || (atts === null || atts === void 0 ? void 0 : atts.results);
            try {
                this.customizeSortSwitch(model, atts, options);
            } catch (error) {
                console.log('Customize Switch Error', error);
            }
            if (results) results.forEach(function(result) {
                _this.addGeneratedProperty(result);
            });
        }
    },
    addGeneratedProperty: function addGeneratedProperty(result) {
        var key = (0, $7cBfa.getPropertyValue)(result, 'mes:key');
        result.properties['generatedProperty'] = (0, $7cBfa.createHtmlProperty)('generatedProperty', key);
    },
    /*************************************************************
     * Name: customizeSortSwitch
     * Purpose: Update sthe sort switch widget for customer needs
     * Params: model
     *         atts
     *         options
     *************************************************************/ customizeSortSwitch: function customizeSortSwitch(model, atts, options) {
        var orderable = [
            {
                name: 'mes:relevance',
                localized_name: 'Relevance'
            },
            {
                name: 'mes:date',
                localized_name: "Decision Date"
            }
        ];
        atts.orderable = orderable;
    }
});
$4cb0599627fba033$var$Application.launch = function() {
    window.app = new $4cb0599627fba033$var$Application({
        initializeModels: function(app) {
            return app.createModels();
        }
    });
    // close welcome modal if user clicks outside of modal content
    window.onclick = function(event) {
        if (event.target.id == 'welcomeModal') this.app.closeWelcomeModal();
    };
    // download function
    window.downloadDocument = function(url, title) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $bySJi._)(function() {
            var response, blob, blobUrl, a, error;
            return (0, $hNV7h.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            fetch(url, {
                                credentials: "include"
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        return [
                            4,
                            response.blob()
                        ];
                    case 2:
                        blob = _state.sent();
                        blobUrl = URL.createObjectURL(blob);
                        a = document.createElement("a");
                        a.href = blobUrl;
                        a.download = title + ".pdf";
                        a.click();
                        URL.revokeObjectURL(blobUrl);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.error("Error downloading document:", error.message);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    // share function
    window.shareDocument = function(encodedUrl, clickedElement) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $bySJi._)(function() {
            var url, error;
            return (0, $hNV7h.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        url = decodeURIComponent(encodedUrl);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            navigator.clipboard.writeText(url)
                        ];
                    case 2:
                        _state.sent();
                        showShareNotification("Link copied to clipboard!", clickedElement);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.error("Error copying link to clipboard:", error);
                        showShareNotification("Unable to copy the link. Please copy it manually.", clickedElement);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    // share notification
    function showShareNotification(message, clickedElement) {
        var notification = document.getElementById("shareNotification");
        if (!notification) {
            notification = document.createElement("div");
            notification.id = "shareNotification";
            notification.style.position = "fixed";
            notification.style.zIndex = "9999";
            notification.style.padding = "8px 14px";
            notification.style.backgroundColor = "#333";
            notification.style.color = "#fff";
            notification.style.borderRadius = "4px";
            notification.style.boxShadow = "0 2px 8px rgba(0,0,0,0.25)";
            notification.style.fontSize = "14px";
            notification.style.transition = "opacity 0.3s ease";
            document.body.appendChild(notification);
        }
        notification.textContent = message;
        var rect = clickedElement.getBoundingClientRect();
        notification.style.left = "".concat(rect.left, "px");
        notification.style.top = "".concat(rect.bottom + 8, "px");
        notification.style.opacity = "1";
        clearTimeout(notification.hideTimeout);
        notification.hideTimeout = setTimeout(function() {
            notification.style.opacity = "0";
        }, 2000);
    }
};
var $4cb0599627fba033$export$2e2bcd8739ae039 = $4cb0599627fba033$var$Application;

});
parcelRegister("bySJi", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $86ad52dce5dcf5b6$export$71511d61b312f219; });
function $86ad52dce5dcf5b6$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $86ad52dce5dcf5b6$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $86ad52dce5dcf5b6$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $86ad52dce5dcf5b6$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

});

parcelRegister("hNV7h", function(module, exports) {

$parcel$export(module.exports, "__generator", function () { return $cf63516cb6db737d$export$67ebef60e6f28a6; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ 
var $kxwvo = parcelRequire("kxwvo");
var $cf63516cb6db737d$var$extendStatics = function extendStatics1(d, b) {
    $cf63516cb6db737d$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $cf63516cb6db737d$var$extendStatics(d, b);
};
function $cf63516cb6db737d$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $cf63516cb6db737d$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $cf63516cb6db737d$export$18ce0697a983be9b = function __assign1() {
    $cf63516cb6db737d$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $cf63516cb6db737d$export$18ce0697a983be9b.apply(this, arguments);
};
function $cf63516cb6db737d$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $cf63516cb6db737d$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $kxwvo._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $cf63516cb6db737d$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $cf63516cb6db737d$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $kxwvo._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $cf63516cb6db737d$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $cf63516cb6db737d$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $kxwvo._)(x)) === "symbol" ? x : "".concat(x);
}
function $cf63516cb6db737d$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $kxwvo._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $cf63516cb6db737d$export$f1db080c865becb9(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $kxwvo._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $cf63516cb6db737d$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $cf63516cb6db737d$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $cf63516cb6db737d$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $cf63516cb6db737d$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $cf63516cb6db737d$export$45d3717a4c69092e(o, m, p);
}
function $cf63516cb6db737d$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $cf63516cb6db737d$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $cf63516cb6db737d$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($cf63516cb6db737d$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $cf63516cb6db737d$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $cf63516cb6db737d$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $cf63516cb6db737d$export$10c90e4f7922046c(v) {
    return this instanceof $cf63516cb6db737d$export$10c90e4f7922046c ? (this.v = v, this) : new $cf63516cb6db737d$export$10c90e4f7922046c(v);
}
function $cf63516cb6db737d$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $cf63516cb6db737d$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $cf63516cb6db737d$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $cf63516cb6db737d$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $cf63516cb6db737d$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $cf63516cb6db737d$export$19a8beecd37a4c45 === "function" ? $cf63516cb6db737d$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $cf63516cb6db737d$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $cf63516cb6db737d$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $cf63516cb6db737d$var$ownKeys = function ownKeys1(o) {
    $cf63516cb6db737d$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $cf63516cb6db737d$var$ownKeys(o);
};
function $cf63516cb6db737d$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $cf63516cb6db737d$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $cf63516cb6db737d$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $cf63516cb6db737d$var$__setModuleDefault(result, mod);
    return result;
}
function $cf63516cb6db737d$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $cf63516cb6db737d$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $cf63516cb6db737d$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $cf63516cb6db737d$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || (typeof receiver === "undefined" ? "undefined" : (0, $kxwvo._)(receiver)) !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $cf63516cb6db737d$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if ((typeof value === "undefined" ? "undefined" : (0, $kxwvo._)(value)) !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function dispose() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $cf63516cb6db737d$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $cf63516cb6db737d$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $cf63516cb6db737d$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $cf63516cb6db737d$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $cf63516cb6db737d$export$2e2bcd8739ae039 = {
    __extends: $cf63516cb6db737d$export$a8ba968b8961cb8a,
    __assign: $cf63516cb6db737d$export$18ce0697a983be9b,
    __rest: $cf63516cb6db737d$export$3c9a16f847548506,
    __decorate: $cf63516cb6db737d$export$29e00dfd3077644b,
    __param: $cf63516cb6db737d$export$d5ad3fd78186038f,
    __esDecorate: $cf63516cb6db737d$export$3a84e1ae4e97e9b0,
    __runInitializers: $cf63516cb6db737d$export$d831c04e792af3d,
    __propKey: $cf63516cb6db737d$export$6a2a36740a146cb8,
    __setFunctionName: $cf63516cb6db737d$export$d1a06452d3489bc7,
    __metadata: $cf63516cb6db737d$export$f1db080c865becb9,
    __awaiter: $cf63516cb6db737d$export$1050f835b63b671e,
    __generator: $cf63516cb6db737d$export$67ebef60e6f28a6,
    __createBinding: $cf63516cb6db737d$export$45d3717a4c69092e,
    __exportStar: $cf63516cb6db737d$export$f33643c0debef087,
    __values: $cf63516cb6db737d$export$19a8beecd37a4c45,
    __read: $cf63516cb6db737d$export$8d051b38c9118094,
    __spread: $cf63516cb6db737d$export$afc72e2116322959,
    __spreadArrays: $cf63516cb6db737d$export$6388937ca91ccae8,
    __spreadArray: $cf63516cb6db737d$export$1216008129fb82ed,
    __await: $cf63516cb6db737d$export$10c90e4f7922046c,
    __asyncGenerator: $cf63516cb6db737d$export$e427f37a30a4de9b,
    __asyncDelegator: $cf63516cb6db737d$export$bbd80228419bb833,
    __asyncValues: $cf63516cb6db737d$export$e3b29a3d6162315f,
    __makeTemplateObject: $cf63516cb6db737d$export$4fb47efe1390b86f,
    __importStar: $cf63516cb6db737d$export$c21735bcef00d192,
    __importDefault: $cf63516cb6db737d$export$da59b14a69baef04,
    __classPrivateFieldGet: $cf63516cb6db737d$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $cf63516cb6db737d$export$d40a35129aaff81f,
    __classPrivateFieldIn: $cf63516cb6db737d$export$81fdc39f203e4e04,
    __addDisposableResource: $cf63516cb6db737d$export$88ac25d8e944e405,
    __disposeResources: $cf63516cb6db737d$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $cf63516cb6db737d$export$889dfb5d17574b0b
};

});
parcelRegister("kxwvo", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ef401a9719c29cec$export$71511d61b312f219; });
function $ef401a9719c29cec$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});


parcelRegister("3yhJs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $68a68aeb2f0be500$export$2e2bcd8739ae039; });
/**************************************************************************
 * File: actions.ts
 * Notes: Functions for user and UI actions.
 **************************************************************************/ var $68a68aeb2f0be500$var$$ = Mindbreeze['require']('jquery'); //initialize jquery library
var $68a68aeb2f0be500$export$2e2bcd8739ae039 = {
    /************************************************
   * Name: closeWelcomeModal
   * Note: Close the welcome modal
   ***********************************************/ closeWelcomeModal: function closeWelcomeModal() {
        var welcomeModal = $68a68aeb2f0be500$var$$('#welcomeModal');
        welcomeModal.hide();
    }
};

});

parcelRegister("hHK49", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f0850b722d3d9674$export$2e2bcd8739ae039; });

var $9AiRe = parcelRequire("9AiRe");

var $8VPGW = parcelRequire("8VPGW");

var $GS9df = parcelRequire("GS9df");

var $4CK6k = parcelRequire("4CK6k");

var $eA8md = parcelRequire("eA8md");
var $f0850b722d3d9674$var$UiState = /*#__PURE__*/ function(Base) {
    "use strict";
    (0, $4CK6k._)(UiState, Base);
    function UiState() {
        (0, $8VPGW._)(this, UiState);
        return (0, $9AiRe._)(this, UiState, arguments);
    }
    (0, $GS9df._)(UiState, [
        {
            key: "defaults",
            value: function defaults() {
                return {
                    language: document.documentElement.lang
                };
            }
        }
    ]);
    return UiState;
}((0, $eA8md.default));
var $f0850b722d3d9674$export$2e2bcd8739ae039 = $f0850b722d3d9674$var$UiState;

});
parcelRegister("9AiRe", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $6fa61a97167d71fe$export$71511d61b312f219; });

var $iwjhA = parcelRequire("iwjhA");

var $iiQ5R = parcelRequire("iiQ5R");

var $dCQrF = parcelRequire("dCQrF");
function $6fa61a97167d71fe$export$71511d61b312f219(_this, derived, args) {
    // Super
    derived = (0, $iwjhA._)(derived);
    return (0, $dCQrF._)(_this, (0, $iiQ5R._)() ? Reflect.construct(derived, args || [], (0, $iwjhA._)(_this).constructor) : derived.apply(_this, args));
}

});
parcelRegister("iwjhA", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d7ba2c439c1a6819$export$71511d61b312f219; });
function $d7ba2c439c1a6819$export$71511d61b312f219(o) {
    $d7ba2c439c1a6819$export$71511d61b312f219 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $d7ba2c439c1a6819$export$71511d61b312f219(o);
}

});

parcelRegister("iiQ5R", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d53251199d0d5343$export$71511d61b312f219; });
function $d53251199d0d5343$export$71511d61b312f219() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return ($d53251199d0d5343$export$71511d61b312f219 = function() {
        return !!result;
    })();
}

});

parcelRegister("dCQrF", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $9eb781803ca01aab$export$71511d61b312f219; });

var $ea3aI = parcelRequire("ea3aI");

var $kxwvo = parcelRequire("kxwvo");
function $9eb781803ca01aab$export$71511d61b312f219(self, call) {
    if (call && ((0, $kxwvo._)(call) === "object" || typeof call === "function")) return call;
    return (0, $ea3aI._)(self);
}

});
parcelRegister("ea3aI", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a4f475ba1c623b97$export$71511d61b312f219; });
function $a4f475ba1c623b97$export$71511d61b312f219(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});



parcelRegister("8VPGW", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $680bbe78b747f05b$export$71511d61b312f219; });
function $680bbe78b747f05b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("GS9df", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $080decf152e5d61a$export$71511d61b312f219; });
function $080decf152e5d61a$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $080decf152e5d61a$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $080decf152e5d61a$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $080decf152e5d61a$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("4CK6k", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $35de78c40129e5f3$export$71511d61b312f219; });

var $hDZ2U = parcelRequire("hDZ2U");
function $35de78c40129e5f3$export$71511d61b312f219(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $hDZ2U._)(subClass, superClass);
}

});
parcelRegister("hDZ2U", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $cd856ea8e7bfd171$export$71511d61b312f219; });
function $cd856ea8e7bfd171$export$71511d61b312f219(o, p) {
    $cd856ea8e7bfd171$export$71511d61b312f219 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $cd856ea8e7bfd171$export$71511d61b312f219(o, p);
}

});


parcelRegister("eA8md", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b0d7be186563f213$export$2e2bcd8739ae039; });

var $9AiRe = parcelRequire("9AiRe");

var $8VPGW = parcelRequire("8VPGW");

var $GS9df = parcelRequire("GS9df");

var $jKzhr = parcelRequire("jKzhr");

var $iwjhA = parcelRequire("iwjhA");

var $4CK6k = parcelRequire("4CK6k");

var $39fBz = parcelRequire("39fBz");

var $kxwvo = parcelRequire("kxwvo");
var $b0d7be186563f213$var$Model = Mindbreeze['require']('backbone').Model;
var $b0d7be186563f213$var$PropertiesModel = Mindbreeze['require']('model/properties');
var $b0d7be186563f213$export$2e2bcd8739ae039 = /*#__PURE__*/ function(Model) {
    "use strict";
    (0, $4CK6k._)(Base, Model);
    function Base() {
        (0, $8VPGW._)(this, Base);
        return (0, $9AiRe._)(this, Base, arguments);
    }
    (0, $GS9df._)(Base, [
        {
            key: "get",
            value: function get(key) {
                return new $b0d7be186563f213$var$PropertiesModel(this.attributes).get(key, {
                    format: 'VALUE'
                });
            }
        },
        {
            key: "set",
            value: function set(key, val, options) {
                for(var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++){
                    rest[_key - 3] = arguments[_key];
                }
                var _$_get;
                if (key == null) return this;
                var attrs;
                if ((typeof key === "undefined" ? "undefined" : (0, $kxwvo._)(key)) === 'object') {
                    attrs = key;
                    options = val;
                } else (attrs = {})[key] = val;
                (_$_get = (0, $jKzhr._)((0, $iwjhA._)(Base.prototype), "set", this)).call.apply(_$_get, [
                    this,
                    key,
                    val,
                    options
                ].concat((0, $39fBz._)(rest)));
            }
        },
        {
            key: "submodel",
            value: function submodel(path) {
                return this.get(path);
            }
        }
    ]);
    return Base;
}($b0d7be186563f213$var$Model);

});
parcelRegister("jKzhr", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e60dae275a9ba559$export$71511d61b312f219; });

var $1uChC = parcelRequire("1uChC");
function $e60dae275a9ba559$export$71511d61b312f219(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $e60dae275a9ba559$export$71511d61b312f219 = Reflect.get;
    else $e60dae275a9ba559$export$71511d61b312f219 = function get(target, property, receiver) {
        var base = (0, $1uChC._)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $e60dae275a9ba559$export$71511d61b312f219(target, property, receiver || target);
}

});
parcelRegister("1uChC", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $11664a0d89fcc474$export$71511d61b312f219; });

var $iwjhA = parcelRequire("iwjhA");
function $11664a0d89fcc474$export$71511d61b312f219(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $iwjhA._)(object);
        if (object === null) break;
    }
    return object;
}

});


parcelRegister("39fBz", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $24ae513106cda17f$export$71511d61b312f219; });

var $etYta = parcelRequire("etYta");

var $3tIiS = parcelRequire("3tIiS");

var $cSqTb = parcelRequire("cSqTb");

var $gWbq8 = parcelRequire("gWbq8");
function $24ae513106cda17f$export$71511d61b312f219(arr) {
    return (0, $etYta._)(arr) || (0, $3tIiS._)(arr) || (0, $gWbq8._)(arr) || (0, $cSqTb._)();
}

});
parcelRegister("etYta", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a8b2ae165e0be36d$export$71511d61b312f219; });

var $44vCb = parcelRequire("44vCb");
function $a8b2ae165e0be36d$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $44vCb._)(arr);
}

});
parcelRegister("44vCb", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $2f700f2dc6c708b9$export$71511d61b312f219; });
function $2f700f2dc6c708b9$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("3tIiS", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $2886724bbc6a91f1$export$71511d61b312f219; });
function $2886724bbc6a91f1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("cSqTb", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $95ff62c3e1fd3929$export$71511d61b312f219; });
function $95ff62c3e1fd3929$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("gWbq8", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c54aec015f737318$export$71511d61b312f219; });

var $44vCb = parcelRequire("44vCb");
function $c54aec015f737318$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $44vCb._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $44vCb._)(o, minLen);
}

});




parcelRegister("7cBfa", function(module, exports) {

$parcel$export(module.exports, "getPropertyValue", function () { return $c9e0628e07735589$export$698ea9d8553982f9; });
$parcel$export(module.exports, "createHtmlProperty", function () { return $c9e0628e07735589$export$abfb758ba901fe79; });
var $c9e0628e07735589$var$PropertiesModel = Mindbreeze['require']('model/properties');
function $c9e0628e07735589$export$698ea9d8553982f9(result, propertyName) {
    if (!result) return;
    return new $c9e0628e07735589$var$PropertiesModel(result.properties).get(propertyName, {
        format: 'VALUE'
    });
}
function $c9e0628e07735589$export$abfb758ba901fe79(propertyName) {
    for(var _len = arguments.length, html = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        html[_key - 1] = arguments[_key];
    }
    return {
        id: propertyName,
        name: propertyName,
        data: html.map(function(value) {
            return {
                html: value
            };
        })
    };
}

});


/**************************************************************************
 * File: index.ts
 * Notes: Base javascript script used to import client js libraries and
 * initialize application. All extended application is found in
 * application.js
 **************************************************************************/ var $973d702f9262ef85$var$MINDBREEZE_IMPORTS = [
    'api/v2/api',
    'client/application',
    'i18n/i18n',
    'model/properties',
    'backbone',
    'jquery'
];

Mindbreeze['require']($973d702f9262ef85$var$MINDBREEZE_IMPORTS, function() {
    var Application = (parcelRequire("7JIDn")).default;
    Application.launch();
});

})();
//# sourceMappingURL=html.6a5ee51f.js.map
